import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledDiscountItems = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  font-family: ${(props) => props.theme.fontText};

  .banner-wrapper {
    padding: 60px 0 40px 0 !important;
  }
    
  .banner-wrapper * {
    padding: 0 !important;
  }

  .product-slider-container {
    padding: 0 0 20px 0;
  }

  .slick-dots {
    position: relative;
    padding: 40px 12px;
  }

  .view-all-items-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0 50px 0;

    button {
      font-family: ${({ theme }) => theme.fontText};
    }
  }

  .title {
    display: none;
  }

  .row {
    margin-left: -15px;
    margin-right: -15px;
  }

  .slick-track {
    display: flex;
  }

  .slick-slide {
    height: auto;

    &>div {
      width: 100%;
      padding: 6px 15px;
      display: flex;
    }

    .carousel-card-product {
      display: flex !important;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .product-slider-container {
      padding: 0 0 20px 0;
    }

    .title {
      h1 {
        font-size: 1.125rem !important;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .title {
      display: block;

      h1 {
        font-size: 18px;
        margin: 0;
        padding: 4px 0 20px 0;
        line-height: 18px;
        font-weight: 600;
      }
    }

    .view-all-items-button {
      width: 100%;
      padding: 0 20px 45px 20px;
      a {
        width: 100%;
      }
      button {
        width: 100%;
        height: 30px;
        padding: 0;
      }
    }

    .product-slider-container {
      padding: 0 0 20px 0;

      .slick-active > div {
        width: 100%;
      }
    }

    .slick-slide {
      display: grid !important;
      grid-template-columns: 1fr;
    }

    .slick-dots {
      padding: 20px 12px;
    }

  }
`;
